var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zg-bio"},[(_vm.name)?_c('h2',[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bio"},[(_vm.$slots.default)?_vm._t("default"):(_vm.text)?_c('p',[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")]):_vm._e()],2),_vm._v(" "),(_vm.date)?_c('span',[_vm._v("\n    "+_vm._s(_vm.date)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.link && _vm.link.href && _vm.link.text)?_c('zg-button-link',{attrs:{"href":_vm.link.href,"text":_vm.link.text,"button-props":{
      link: true,
      size: 'medium',
      icons: { right: 'arrow-forward' }
    }}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }